import React from "react"
import PropTypes from "prop-types"
import i18n from "i18n"

const CertHistoryRowContentTableHead = ({ currencySymbol, isInvoicing }) => (
  <>
    <thead>
      <th></th>
      <th colSpan="4"></th>
      <th></th>
      <th></th>
      <th colSpan="2" style={{ borderLeft: "1px solid #bbbbbb" }}>
        {i18n.t("Precio Cliente")}
      </th>
      <th colSpan="6" style={{ borderLeft: "1px solid #bbbbbb" }}>
        {i18n.t("Certificaciones")}
      </th>
      {isInvoicing && (
        <th colSpan="5" style={{ borderLeft: "1px solid #bbbbbb" }}>
          {i18n.t("Facturación")}
        </th>
      )}
    </thead>
    <thead>
      <th>{i18n.t("Ref.")}</th>
      <th colSpan="4">{i18n.t("Descripción")}</th>
      <th>{i18n.t("Med.")}</th>
      <th>{i18n.t("Ud.")}</th>
      <th style={{ borderLeft: "1px solid #bbbbbb" }}>{currencySymbol}/u</th>
      <th>{i18n.t("Total")}</th>
      <th style={{ borderLeft: "1px solid #bbbbbb" }}>{i18n.t("Var. Ud.")}</th>
      <th>{i18n.t("Var. %")}</th>
      <th>
        {i18n.t("Var.")} {currencySymbol}
      </th>
      <th>{i18n.t("Total %")}</th>
      <th>{i18n.t("Total Ud.")}</th>
      <th>
        {i18n.t("Total")} {currencySymbol}
      </th>
      {isInvoicing && (
        <>
          <th style={{ borderLeft: "1px solid #bbbbbb" }}>
            {i18n.t("Facturado")}
          </th>
          <th>{i18n.t("Pendiente")}</th>
          <th>{i18n.t("% a facturar")}</th>
          <th>{i18n.t("Importe")}</th>
          <th></th>
        </>
      )}
    </thead>
  </>
)

CertHistoryRowContentTableHead.propTypes = {
  currencySymbol: PropTypes.string.isRequired,
  isInvoicing: PropTypes.bool,
}

export default CertHistoryRowContentTableHead
